import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { LocalizationService } from '../../../../services/localization.service';
import { OrderStateService } from '../../../order/services/order-state.service';
import { PickupPointGroup } from '../../models/pickup-point-group';
import { BookingOrderService } from '../../services/booking-order.service';

@Component({
  selector: 'app-booking-basket-simple-view',
  templateUrl: './booking-basket-simple-view.component.html',
  styleUrls: ['./booking-basket-simple-view.component.css']
})
export class BookingBasketSimpleViewComponent implements OnInit {

  allowDeleteLastDate: boolean;

  constructor(
    private bookingOrderService: BookingOrderService,
    private localizationService: LocalizationService,
    private router: Router,
    private orderStateService: OrderStateService,
  ) {
  }

  ngOnInit() {
    this.allowDeleteLastDate = this.router.url === '/booking/single/product';
  }

  get title(): string {
    return 'Shopping Cart';
  }

  get prefix(): string {
    return '';
  }

  get weekShort(): string {
    const date = this.bookingOrderService.selectedBookingDate;
    if (date == null) {
      return '';
    }
    const week = this.localizationService.getWeekdayNameShortByDate(date);
    return week.substring(0, Math.min(week.length, 2));
  }

  get day(): string {
    const date = this.bookingOrderService.selectedBookingDate;
    if (date == null) {
      return '';
    }

    return date.getDate().toString();
  }

  get monthShort(): string {
    const date = this.bookingOrderService.selectedBookingDate;
    if (date == null) {
      return '';
    }

    const month = this.localizationService.getMonthNameLongByDate(date);
    return month.substring(0, Math.min(month.length, 3));
  }

  get time(): string {
    const date = this.bookingOrderService.selectedBookingDate;
    if (date == null) {
      return '';
    }

    return environment.globalSettings.getTimeStr(date);
  }

  onOrderLinesRemovedByDate(date: Date): void {
    if (!date ||
      !this.bookingOrderService.selectedBookingDate ||
      this.bookingOrderService.selectedBookingDate.getTime() !== date.getTime()) {
      this.bookingOrderService.singleCache.updateInvalidReason();
      return;
    }

    this.bookingOrderService.singleCache.ordersCache.resetCacheLinesQuantity();
    this.bookingOrderService.singleCache.ordersCache.resetIsCacheLinesQtyCalculatedForAllChachedOders();
    this.orderStateService.orderSaveToLocalStorage();
    this.bookingOrderService.singleCache.updateInvalidReason();
    this.bookingOrderService.messageChange.emit();
  }

  get pickUpPointName(): string {
    let pointName = '';
    let groupId = 0;
    let group: PickupPointGroup = null;
    const pickupPointId = this.bookingOrderService.selectedPickupPointId;

    if (!pickupPointId) {
      return pointName;
    }

    const pickupPoints = this.bookingOrderService.areaAreaItemPack.pickupPoints;
    for (const pickUpPoint of pickupPoints) {
      if (pickUpPoint.id === pickupPointId) {
        pointName = ' // ' + pickUpPoint.name;
        groupId = pickUpPoint.groupId;
        break;
      }
    }

    if (groupId) {
      group = this.bookingOrderService.areaAreaItemPack.pickupPointGroups.find(x => x.id === groupId);
    }

    const groupName = group ? '// ' + group.name : '';
    return groupName + pointName;
  }
}
